export const traverseThreeObject = (object, command) => {
	if (!object) return;
	command(object);
	if (object.children && object.children.length) {
		object.children.forEach((child) => traverseThreeObject(child, command));
	}
};

export default traverseThreeObject;
